import { zergApi } from "@/service/zerg";

class RolesAreaService {

    async getRoles(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/get-roles", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getRoleById(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/get-role-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveRole(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/save-role", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAreas(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/get-areas", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataAreaById(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/get-data-area-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getRolesForSelect() {
        try {
            const data = await zergApi.post("/setting/roles-area/get-roles-for-select");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveArea(params) {
        try {
            const data = await zergApi.post("/setting/roles-area/save-area", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new RolesAreaService();